import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import TopImage from "../assets/Images/Display_Top_Banner.webp";
import { getAllCourtsData } from "../Libs/api";
import "./Display.css";

// Individual Scoreboard Component
const Scoreboard = ({ courtData, index }) => {
  console.log(index);

  // If no active match, show empty court (regardless of last match)
  if (!courtData.hasActiveMatch) {
    return (
      <div className="scoreboard-banner">
        {/* Top orange border - only show for courts in second row and beyond */}
        {index >= 2 && <div className="top-border"></div>}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className="court-label text-center">COURT {courtData.court}</div>
        </div>
        <div className="scoreboard-content">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
              fontSize: "24px",
              color: "#666",
            }}
          >
            No Active Match
          </div>
        </div>
      </div>
    );
  }

  const match = courtData.match;
  const currentSet = match.sets.find(
    (set) => set.setNumber === match.currentSet
  );
  const leftScore = currentSet ? currentSet.teamAScore : 0;
  const rightScore = currentSet ? currentSet.teamBScore : 0;

  // Calculate sets won
  const leftSets = match.sets.filter(
    (set) => set.winner === match.teamA
  ).length;
  const rightSets = match.sets.filter(
    (set) => set.winner === match.teamB
  ).length;

  // Get player names
  const leftPlayers = match.teamA ? match.teamA.split(" & ") : ["", ""];
  const rightPlayers = match.teamB ? match.teamB.split(" & ") : ["", ""];

  // Determine serving player
  const servingPlayer = match.teamAServe ? "left" : "right";

  // Get team logos
  const teamALogo =
    match.teamALogo ||
    match.teamAPlayer1?.team?.logo ||
    match.teamAPlayer2?.team?.logo;
  const teamBLogo =
    match.teamBLogo ||
    match.teamBPlayer1?.team?.logo ||
    match.teamBPlayer2?.team?.logo;

  return (
    <div className="scoreboard-banner">
      {/* Top orange border - only show for courts in second row and beyond */}
      {index >= 2 && <div className="top-border"></div>}

      {/* Court label with team logos */}
      <div
        className=""
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          gap: "12px",
        }}
      >
        {/* Team A Logo */}
        {teamALogo && (
          <div
            style={{
              width: "clamp(40px, 5vw, 80px)",
              height: "clamp(40px, 5vw, 80px)",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #fff",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              flexShrink: 0,
            }}
            className="logo-team"
          >
            <img
              src={teamALogo}
              alt="Team A Logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        )}

        <div className="court-label text-center">COURT {courtData.court}</div>

        {/* Team B Logo */}
        {teamBLogo && (
          <div
            style={{
              width: "clamp(40px, 5vw, 80px)",
              height: "clamp(40px, 5vw, 80px)",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #fff",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              flexShrink: 0,
            }}
            className="logo-team"
          >
            <img
              src={teamBLogo}
              alt="Team B Logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        )}
      </div>

      {/* Main scoreboard content */}
      <div className="scoreboard-content">
        {/* Left side players */}
        <div className="players-section left-players">
          <div>
            <div className="player-row">
              <div className="player-name">{leftPlayers[0] || ""}</div>
            </div>
            <div className="player-row">
              <div className="player-name">{leftPlayers[1] || ""}</div>
            </div>
          </div>
          {servingPlayer === "left" ? (
            <div className="serving-indicator"></div>
          ) : (
            <div className="serving-empty"></div>
          )}
        </div>

        {/* Center scores */}
        <div className="scores-section">
          <div className="main-score">
            <span className="score-number">{leftScore}</span>
            <span className="score-separator">-</span>
            <span className="score-number">{rightScore}</span>
          </div>
        </div>

        {/* Right side players */}
        <div className="players-section right-players">
          {servingPlayer === "right" ? (
            <div className="serving-indicator"></div>
          ) : (
            <div className="serving-empty"></div>
          )}

          <div>
            <div className="player-row">
              <div className="player-name">{rightPlayers[0] || ""}</div>
            </div>
            <div className="player-row">
              <div className="player-name">{rightPlayers[1] || ""}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="sets-score">
        <div className="sets-text">
          <span className="sets-number">{leftSets}</span>
          <span className="sets-label">SETS</span>
          <span className="sets-number">{rightSets}</span>
        </div>
      </div>
    </div>
  );
};

const Display = () => {
  const [courtsData, setCourtsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [socket, setSocket] = useState(null);

  // Fetch initial courts data
  const fetchCourtsData = async () => {
    try {
      const response = await getAllCourtsData();
      if (response.success) {
        setCourtsData(response.data);
      }
    } catch (error) {
      console.error("Error fetching courts data:", error);
    } finally {
      setLoading(false);
    }
  };

  // WebSocket connection
  useEffect(() => {
    const newSocket = io(
      // "https://api-third-shot-score-684526581556.asia-south1.run.app",
      "https://api-third-shot-score-684526581556.asia-south1.run.app",
      {
        transports: ["websocket", "polling"],
        timeout: 20000,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        maxReconnectionAttempts: 10,
        forceNew: true,
      }
    );

    // Connection event handlers
    newSocket.on("connect", () => {
      console.log("✅ Display WebSocket connected successfully");
      // Join live score room for real-time updates
      newSocket.emit("joinLiveScore");
      // Join display settings room for display configuration updates
      newSocket.emit("joinDisplaySettings");
    });

    newSocket.on("disconnect", (reason) => {
      console.log("❌ Display WebSocket disconnected:", reason);
    });

    newSocket.on("connect_error", (error) => {
      console.error("❌ Display WebSocket connection error:", error);
    });

    newSocket.on("reconnect", (attemptNumber) => {
      console.log(
        "🔄 Display WebSocket reconnected after",
        attemptNumber,
        "attempts"
      );
      // Re-join live score room after reconnection
      newSocket.emit("joinLiveScore");
      // Re-join display settings room after reconnection
      newSocket.emit("joinDisplaySettings");
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, []);

  // Handle WebSocket messages
  useEffect(() => {
    if (!socket) return;

    // Listen for all courts data updates
    socket.on("allCourtsUpdate", (data) => {
      console.log("📊 Received all courts update:", data);
      setCourtsData(data.courtsData);
    });

    // Listen for individual match updates
    socket.on("scoreUpdate", () => {
      console.log("📊 Score update received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("setEnd", () => {
      console.log("📊 Set end received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("serveUpdate", () => {
      console.log("📊 Serve update received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("matchEnd", () => {
      console.log("📊 Match end received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("activeMatchChange", () => {
      console.log("📊 Active match change received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("courtCleared", () => {
      console.log("📊 Court cleared received, refreshing courts data");
      fetchCourtsData();
    });

    socket.on("undoScore", () => {
      console.log("📊 Undo score received, refreshing courts data");
      fetchCourtsData();
    });

    return () => {
      socket.off("allCourtsUpdate");
      socket.off("scoreUpdate");
      socket.off("setEnd");
      socket.off("serveUpdate");
      socket.off("matchEnd");
      socket.off("activeMatchChange");
      socket.off("courtCleared");
      socket.off("undoScore");
    };
  }, [socket]);

  // Fetch initial data
  useEffect(() => {
    fetchCourtsData();
  }, []);

  if (loading) {
    return (
      <div className="display-container">
        <div className="image-wrapper">
          <img src={TopImage} alt="Top Image" className="responsive-image" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "400px",
            fontSize: "24px",
            color: "#666",
          }}
        >
          Loading courts data...
        </div>
      </div>
    );
  }

  return (
    <div className="display-container" style={{ padding: 0 }}>
      <div className="image-wrapper">
        <img src={TopImage} alt="Top Image" className="responsive-image" />
      </div>

      <div className="courts-grid">
        {courtsData.map((courtData, index) => (
          <Scoreboard
            key={courtData.court}
            courtData={courtData}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default Display;
